export const OUTCOME_LABELS = {
  no_answer: 'No answer',
  rejected: 'Rejected',
  accepted_on_call: 'Accepted on call',
  callback_later: 'Callback later',
};

export const REJECTION_LABELS = {
  price_too_low: 'Price too low',
  price_too_high: 'Price too high',
  long_distance: 'Long distance',
  bad_timing: 'Bad timing',
  already_busy: 'Already busy',
  personal: 'Personal',
  other: 'Other',
};

export function outreachForVehicle(history, vehicleId) {
  return (history || [])
    .filter((row) => Number(row.vehicle_id) === Number(vehicleId))
    .sort((a, b) => new Date(b.logged_at || 0) - new Date(a.logged_at || 0));
}

export function getOutreachBadgeStyle(outcome) {
  switch (outcome) {
    case 'rejected':
      return { background: '#fee2e2', color: '#b91c1c', border: '1px solid #fecaca' };
    case 'accepted_on_call':
      return { background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0' };
    case 'no_answer':
      return { background: '#f3f4f6', color: '#4b5563', border: '1px solid #e5e7eb' };
    case 'callback_later':
      return { background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a' };
    default:
      return { background: '#dbeafe', color: '#1d4ed8', border: '1px solid #bfdbfe' };
  }
}

export function summarizeOutreach(calls) {
  if (!calls?.length) return null;

  const latest = calls[0];
  const outcome = latest.call_outcome || latest.driver_response;
  const outcomeLabel = OUTCOME_LABELS[outcome] || outcome || 'Called';
  const reasonLabel = latest.rejection_reason_code
    ? REJECTION_LABELS[latest.rejection_reason_code]
      || latest.rejection_reason_code.replace(/_/g, ' ')
    : '';
  const when = latest.logged_at ? new Date(latest.logged_at).toLocaleString() : '';
  const callCount = calls.length;

  const summaryParts = [`Called ${callCount}×`, outcomeLabel];
  if (reasonLabel) summaryParts.push(reasonLabel);

  return {
    callCount,
    latest,
    outcome,
    outcomeLabel,
    reasonLabel,
    when,
    summaryText: summaryParts.join(' · '),
    badgeStyle: getOutreachBadgeStyle(outcome),
  };
}

export function formatOutreachHistoryLine(row) {
  const summary = summarizeOutreach([row]);
  return summary ? summary.summaryText : 'Logged';
}
